module.exports = __webpack_public_path__ + "media/location-service_de_ipad_old.5ea677dc.mp4";